import {CustomersDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_MERGED_CUSTOMERS_CONTRACTORS';

export async function getAllMergedCustomersContractors(
    userData: Record<string, string>,
    params: string,
    page: number
) {
    try {
        const mergedCustomersContractors = await CustomersDao.getAllMergedCustomersContractors(userData.userToken, params, page);

        const metadata = {
            count: mergedCustomersContractors.count,
            next: mergedCustomersContractors.next,
            previous: mergedCustomersContractors.previous
        };

        return {
            metadata,
            data: mergedCustomersContractors
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des clients et fournisseurs.',
            error: error
        });
    }
}
